import React from 'react';
import { Handle, Position } from 'reactflow';

interface DunningNodeProps {
  data: {
    label: string;
    onDelete: () => void;
    onMoveUp: () => void;
    onMoveDown: () => void;
  };
}

const DunningNode: React.FC<DunningNodeProps> = ({ data }) => {
  return (
    <div className="bg-slate-900 text-white p-6 rounded-2xl border border-slate-700 shadow-2xl min-w-[240px] relative">
      <Handle type="target" position={Position.Top} className="!bg-indigo-500 !w-3 !h-3" />
      <div className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-3">Sequence Node</div>
      <div className="text-sm font-bold text-white mb-6">{data.label}</div>
      <div className="flex gap-2">
        <button onClick={data.onMoveUp} className="flex-1 text-[10px] bg-slate-800 hover:bg-slate-700 px-3 py-2 rounded-lg font-black uppercase">↑</button>
        <button onClick={data.onMoveDown} className="flex-1 text-[10px] bg-slate-800 hover:bg-slate-700 px-3 py-2 rounded-lg font-black uppercase">↓</button>
        <button onClick={data.onDelete} className="flex-1 text-[10px] bg-red-900/30 text-red-400 hover:bg-red-900/50 px-3 py-2 rounded-lg font-black uppercase">Delete</button>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-indigo-500 !w-3 !h-3" />
    </div>
  );
};

export default DunningNode;
